// Profile description on the homepage

export const HomepageJobDescription = () => {
  return (
    <p>
      Specializing in utilizing real-time data technologies to create
      low-latency, instant updates, live communication web applications.
      Proficient with React.js, while utilizing several extra features with
      Next.js.
    </p>
  );
};
